export const environment = {
  production: true,
  apiUrl: 'https://api.ccs-test.athabascau.ca',
  envName: 'TEST',
  authority: 'https://cognito-idp.us-west-2.amazonaws.com/us-west-2_m5EUmTnBk',
  clientId: '6cqnbb2em1aimtnic60f6gknh',
  scope: 'email openid profile',
  responseType: 'code',
};
